


import SECTION_1676511135550 from
'../dynamic_section/dynamic_2/template_01';






import HelpSection from '../sections/help/template_02';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const HelpPage = ()=>{
  
return (
  <div id="helpPage" class="page ">
  
  

  
  < SECTION_1676511135550 desktopToggle={ true }
    mobileToggle={ false } label={ `tnc_title` } id={ `tnc_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  <HelpSection desktopTitleToggle={ false }
    mobileTitleToggle={ true }  desktopToggle={ true } mobileToggle={
      true } dropdownTitle={true} backgroundImgTitle={true}/>
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  

  
</div>
)
}

export default HelpPage;